import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 14H8v-2h9a.998.998 0 0 0 .948-.684l2-6a.994.994 0 0 0-.092-.832.994.994 0 0 0-.692-.47L8 2.153V1a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h1v1a1 1 0 0 0 .836.986l10.846 1.808L16.279 10H7a1 1 0 0 0-1 1v3.185A2.995 2.995 0 0 0 4 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h4.37A2.938 2.938 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5-7H1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-1 4H1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M1 4h1a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2m0 4h6a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2"
});

var SvgQuickSaleMajorMonotone = function SvgQuickSaleMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgQuickSaleMajorMonotone as S };